import {
  isNotEmptyArray,
  isNumericArrayValid,
  stringToArray
} from "../utilities/ArrayUtils";

export function isSingleValueValid(val) {
  return !isNaN(val) && val !== "";
}

export function areBasicAnalysisInputsValidNoLibor(cpr, cdr, lossSeverity, delinquency) {
  return isNumericArrayValid(stringToArray(cpr)) &&
    isNumericArrayValid(stringToArray(cdr)) &&
    isNumericArrayValid(stringToArray(lossSeverity)) &&
    isNumericArrayValid(stringToArray(delinquency))
}

export function isBasicAnalysisBodyValid(body, isSingle = true) {
  return body.UserCollateralCashflow != null ||
    areBasicAnalysisInputsValid(body.Cpr, body.Cdr, body.LossSeverity, body.Delinquency, body.Libor, isSingle)
}
// TODO: remove when refactoring portfolio
export function areBasicAnalysisInputsValid(cpr, cdr, lossSeverity, delinquency, libor) {
  return areBasicAnalysisInputsValidNoLibor(cpr, cdr, lossSeverity, delinquency) && isNumericArrayValid(stringToArray(libor))
}

export function isAcisAnalysisBodyValid(body) {
  return body.UserCollateralCashflow != null ||
    areAcisAnalysisInputsValid(body.Cpr, body.Cdr, body.LossSeverity, body.Delinquency, body.OwnedFaceAmt, body.Margin, body.InterestRate)
}
// TODO: remove when refactoring portfolio
export function areAcisAnalysisInputsValid(cpr, cdr, lossSeverity, delinquency, ownedFaceAmt, margin, interestRate) {
  let valid = areBasicAnalysisInputsValidNoLibor(cpr, cdr, lossSeverity, delinquency)
  return valid && isSingleValueValid(ownedFaceAmt) && isSingleValueValid(margin) && isSingleValueValid(interestRate);
}

export function isCirtAnalysisBodyValid(body) {
  return body.UserCollateralCashflow != null ||
  areCirtAnalysisInputsValid(body.Cpr, body.Cdr, body.LossSeverity, body.Delinquency, body.OwnedFaceAmt, body.Margin, body.InterestRate)
}

export function areCirtAnalysisInputsValid(cpr, cdr, lossSeverity, delinquency, ownedFaceAmt, margin, interestRate) {
  let valid = areBasicAnalysisInputsValidNoLibor(cpr, cdr, lossSeverity, delinquency)
  return valid && isSingleValueValid(ownedFaceAmt) && isSingleValueValid(margin) && isSingleValueValid(interestRate);
}

export function createBasicValidationErrorMessageNoLibor(cpr, cdr, lossSeverity, delinquency, isSingle = true) {
  let missing = []
  if (isSingle) {
    if (!isNumericArrayValid(stringToArray(cpr))) missing.push("CPR");
    if (!isNumericArrayValid(stringToArray(cdr))) missing.push("CDR");
  } else {
    if (!isNotEmptyArray(cpr)) missing.push("at least one CPR in matrix");
    if (!isNotEmptyArray(cdr)) missing.push("at least one CDR in matrix");
  }
  if (!isNumericArrayValid(stringToArray(lossSeverity))) missing.push("Loss Severity");
  if (!isNumericArrayValid(stringToArray(delinquency))) missing.push("Delinquency");

  return "Missing valid: " + missing.join(", ")
}

export function createBasicValidationErrorMessage(cpr, cdr, lossSeverity, delinquency, libor, isSingle = true) {
  let missing = []
  if (isSingle) {
    if (!isNumericArrayValid(stringToArray(cpr))) missing.push("CPR");
    if (!isNumericArrayValid(stringToArray(cdr))) missing.push("CDR");
  } else {
    if (!isNotEmptyArray(cpr)) missing.push("at least one CPR in matrix");
    if (!isNotEmptyArray(cdr)) missing.push("at least one CDR in matrix");
  }
  if (!isNumericArrayValid(stringToArray(lossSeverity))) missing.push("Loss Severity");
  if (!isNumericArrayValid(stringToArray(delinquency))) missing.push("Delinquency");
  if (!isNumericArrayValid(stringToArray(libor))) missing.push("LIBOR");

  return "Missing required: " + missing.join(", ")
}

export function createAcisValidationErrorMessage(cpr, cdr, lossSeverity, delinquency, ownedFaceAmt, margin, interestRate, isSingle = true) {
  let message = createBasicValidationErrorMessageNoLibor(cpr, cdr, lossSeverity, delinquency, isSingle)
  let missing = message.split(":")[1].split(",").map(Function.prototype.call, String.prototype.trim).filter(x => x.length)
  if (!isSingleValueValid(ownedFaceAmt)) missing.push("Contract Amount")
  if (!isSingleValueValid(margin)) missing.push("Collateral")
  if (!isSingleValueValid(interestRate)) missing.push("Interest Rate")

  return "Missing required: " + missing.join(", ")
}

export function createCirtValidationErrorMessageFromBody(body) {
  return createCirtValidationErrorMessage(body.Cpr, body.Cdr, body.LossSeverity, body.Delinquency, body.OwnedFaceAmt, body.Margin, body.InterestRate)
}

export function createCirtValidationErrorMessage(cpr, cdr, lossSeverity, delinquency, ownedFaceAmt, margin, interestRate, isSingle = true) {
  let message = createBasicValidationErrorMessageNoLibor(cpr, cdr, lossSeverity, delinquency, isSingle)
  let missing = message.split(":")[1].split(",").map(Function.prototype.call, String.prototype.trim).filter(x => x.length)
  if (!isSingleValueValid(ownedFaceAmt)) missing.push("Contract Amount")
  if (!isSingleValueValid(margin)) missing.push("Collateral")
  if (!isSingleValueValid(interestRate)) missing.push("Interest Rate")

  // if(!isSingleValueValid(ownedFaceAmt)) missing.push("OwnedFaceAmt")
  // if(!isSingleValueValid(retention)) missing.push("Retention")
  // if(!isSingleValueValid(marginTarget)) missing.push("Target Collateral")
  // if(!isSingleValueValid(annualPremium)) missing.push("Annual Premium")
  // if(!isSingleValueValid(regReset)) missing.push("Mos Btwn Resets")

  return "Missing required: " + missing.join(", ")
}

